import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { initGA, logPageView } from "./analytics/analytics";
import ContactPage from "./components/ContactPage";
import BackToTop from "./components/BackToTop";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { HomePage } from "./components/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import StoryPage from "./components/AboutPage/StoryPage";
import TeamPage from "./components/AboutPage/TeamPage";
import ServicesPage from "./components/ServicesPage/ServicesPage";
import SalesPage from "./components/SalesPage/SalesPage";
import SalesDetailPage from "./components/SalesPage/SalesDetailPage";
import NotFound from "./components/NotFound";
import ProtectedAdminRoute from "./components/AdminPage/ProtectedAdminRoute";
import { CartProvider } from "./contexts/CartContext";

export function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    logPageView();
  }, [location]);

  return (
    <CartProvider>
      <ScrollToTop />
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about/story" element={<StoryPage />} />
        <Route path="/about/team" element={<TeamPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/sales" element={<SalesPage />} />
        <Route path="/sales/:slug" element={<SalesDetailPage />} />
        {/* Blog, diagnostics, and parts catalog are temporarily disabled. */}
        <Route path="/admin" element={<ProtectedAdminRoute />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminRoute && <BackToTop />}
      {!isAdminRoute && <Footer />}
    </CartProvider>
  );
}
